<template>
  <div class="animated fadeIn">
    <div>
      <component-header
        title="Edit"
        :hasSearch="false"
        :hasReload="false"
        :hasCreate="false"
        :hasback="true"
        @back-press="$router.push('/manage_own_customer')"
      />
    </div>
    <div>
      <b-row>
        <b-col sm="6">
          <h3 class="p-3">Customer Details</h3>
          <ValidationProvider rules="required" v-slot="{ errors }" name="Customer ID">
            <c-input
              type="text"
              inputId="customerId"
              v-model="currentUser.customerNo"
              lableText="*Customer ID"
            />
            <span class="validate-error">{{ errors[0] }}</span>
          </ValidationProvider>
        </b-col>
        <b-col sm="6">
          <h3 class="p-3">&nbsp;</h3>
          <ValidationProvider rules="required" v-slot="{ errors }" name="Customer Name">
            <c-input
              inputType="text"
              inputId="customername"
              lableText="*Customer Name"
              v-model="currentUser.customerName"
              class="mt-0"
            />
            <span class="validate-error">{{ errors[0] }}</span>
          </ValidationProvider>
        </b-col>
      </b-row>
      <b-row>
        <b-col md-6>
          <ValidationProvider rules="required" v-slot="{ errors }" name="phone number">
            <c-tel-input
              :defaultInput="currentUser.phone"
              v-model="currentUser.phone"
              inputType="number"
              class="m-0"
            />
            <span class="validate-error">{{ errors[0] }}</span>
          </ValidationProvider>
        </b-col>
        <b-col md-6>
          <ValidationProvider rules="required|email" v-slot="{ errors }" name="Email">
            <c-input
              inputType="text"
              inputId="Email"
              lableText="*Email"
              v-model="currentUser.email"
              class="mt-0"
            />
            <span class="validate-error">{{ errors[0] }}</span>
          </ValidationProvider>
        </b-col>
      </b-row>
      <b-row>
        <b-col md-6>
          <ValidationProvider rules="required" v-slot="{ errors }" name="Service ID">
            <c-input
              type="text"
              inputId="serviceId"
              v-model="currentUser.serviceId"
              lableText="*Service ID"
            />
            <span class="validate-error">{{ errors[0] }}</span>
          </ValidationProvider>
        </b-col>
        <b-col md-6>
          <eb-select
            type="select"
            v-model="currentUser.serviceType"
            :selected="currentUser.serviceType"
            :options="['SD', 'HD']"
            label="text"
            :id="'selecttype'"
            placeholder="Service Type(optional)"
          ></eb-select>
        </b-col>
      </b-row>
      <b-row>
        <b-col md-6>
          <ValidationProvider rules="required" v-slot="{ errors }" name="Country">
            <c-input
              type="text"
              inputId="country"
              v-model="currentUser.address.country"
              lableText="*Country"
            />
            <span class="validate-error">{{ errors[0] }}</span>
          </ValidationProvider>
        </b-col>
        <b-col md-6>
          <ValidationProvider rules="required" v-slot="{ errors }" name="State">
            <c-input
              type="text"
              inputId="state"
              v-model="currentUser.address.state"
              lableText="*State"
            />
            <span class="validate-error">{{ errors[0] }}</span>
          </ValidationProvider>
        </b-col>
      </b-row>
      <b-row>
        <b-col md-6>
          <ValidationProvider rules="required" v-slot="{ errors }" name="City">
            <c-input
              type="text"
              inputId="city"
              v-model="currentUser.address.city"
              lableText="*City"
            />
            <span class="validate-error">{{ errors[0] }}</span>
          </ValidationProvider>
        </b-col>
        <b-col md-6>
          <ValidationProvider rules="required" v-slot="{ errors }" name="Street 1">
            <c-input
              type="text"
              inputId="street1"
              v-model="currentUser.address.address1"
              lableText="*Street 1"
            />
            <span class="validate-error">{{ errors[0] }}</span>
          </ValidationProvider>
        </b-col>
      </b-row>
      <b-row>
        <b-col md-6>
          <ValidationProvider rules="required" v-slot="{ errors }" name="Street 2">
            <c-input
              type="text"
              inputId="street 2"
              v-model="currentUser.address.address2"
              lableText="*Street 2"
            />
            <span class="validate-error">{{ errors[0] }}</span>
          </ValidationProvider>
        </b-col>
        <b-col md-6>
          <ValidationProvider rules="required" v-slot="{ errors }" name="zipcode">
            <c-input
              inputType="number"
              inputId="zipcode"
              v-model="currentUser.address.pinCode"
              lableText="*Zipcode"
            />
            <span class="validate-error">{{ errors[0] }}</span>
          </ValidationProvider>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="6">
          <ValidationProvider rules="required" v-slot="{ errors }" name="MSO">
            <c-input type="text" v-model="currentUser.MSO" lableText="*MSO" />
            <span class="validate-error">{{ errors[0] }}</span>
          </ValidationProvider>
        </b-col>
      </b-row>
      <div class="text-center mb-5 mt-5">
        <button
          type="button"
          class="btn btn-lg btn-outline-success ml-3 w-25"
          @click.prevent="handleSubmit"
        >
          Update
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import ebButton from "@/components/FormElements/Button";
import cInput from "@/components/FormElements/CustomInput";
import cTelInput from "@/components/FormElements/MobileNumberInput";
import ebSelect from "@/components/FormElements/Select.vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import currentUser from "@/mixins/currentUser";
import ComponentHeader from "@/components/componentNewHeader";

export default {
  name: "EditCustomer",
  components: {
    ebButton,
    cInput,
    cTelInput,
    ebSelect,
    ValidationProvider,
    ValidationObserver,
    ComponentHeader,
  },
  data() {
    return {
      currentUser: {
        customerNo: "",
        customerName: "",
        createdDate: "",
        service: "",
        customerPhone: "",
        email: "",
        address: {
          address1: "",
          address2: "",
          state: "",
          city: "",
          pinCode: "",
          country: "",
        },
        _id: "",
        phone: "",
        serviceId: "",
        MSO: "",
        serviceType: "",
      },
      loading: false,
    };
  },
  methods: {
    handleSubmit() {
      const data = {
        _id: this.currentUser._id,
        payload: {
          customerName: this.currentUser.customerName,
          email: this.currentUser.email,
          phone: this.currentUser.phone,
          serviceId: this.currentUser.serviceId,
          customerNo: this.currentUser.customerNo,
          MSO: this.currentUser.MSO,
          serviceType: this.currentUser.serviceType,
          address: {
            address1: this.currentUser.address.address1,
            address2: this.currentUser.address.address2,
            state: this.currentUser.address.state,
            city: this.currentUser.address.city,
            pinCode: this.currentUser.address.pinCode,
            country: this.currentUser.address.country,
          },
        },
      };
      this.$store.dispatch("partner/updateCustomer", data).then(() => {
        this.$swal({
          title: "Success",
          text: "Customer updated successfully!!",
          type: "success",
        });
        this.$router.push("/manage_own_customer");
      });
    },
  },
  mounted: async function () {
    this.loading = true;
    Object.assign(this.currentUser, this.$route.params.userData);
    this.loading = false;
  },
};
</script>
